import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-40efc22e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "stocknotes" }
const _hoisted_2 = { class: "list" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "content" }
const _hoisted_6 = { class: "operation" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "K线日期：", -1))
const _hoisted_8 = { class: "editwrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_space = _resolveComponent("a-space")!
  const _component_Divedit = _resolveComponent("Divedit")!
  const _component_optionalshares = _resolveComponent("optionalshares")!
  const _directive_widthoverflowtitle = _resolveDirective("widthoverflowtitle")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.noteslist, (item) => {
            return (_openBlock(), _createElementBlock("li", {
              key: item.ID,
              class: _normalizeClass({'active': _ctx.currentNote.ID === item.ID, 'emptynote': !item.ID}),
              onClick: ($event: any) => (_ctx.viewNote(item))
            }, [
              _withDirectives((_openBlock(), _createElementBlock("div", null, [
                (item.Name)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4, "【" + _toDisplayString(item.Name) + "】", 1))
                  : _createCommentVNode("", true),
                _createTextVNode(_toDisplayString(item.Title), 1)
              ])), [
                [_directive_widthoverflowtitle, item.Title]
              ]),
              _createElementVNode("p", null, _toDisplayString(_ctx.moment(item.PubTime * 1000).format('YYYY-MM-DD HH:mm')), 1)
            ], 10, _hoisted_3))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_a_space, { size: 15 }, {
          default: _withCtx(() => [
            _hoisted_7,
            _createTextVNode(" " + _toDisplayString(_ctx.moment(_ctx.currentNote.PubTime * 1000 || new Date()).format('YYYY-MM-DD HH:mm')), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_Divedit, {
          theme: _ctx.theme,
          value: _ctx.content,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.content) = $event)),
          contenteditable: false
        }, null, 8, ["theme", "value"])
      ])
    ]),
    _createVNode(_component_optionalshares)
  ]))
}